import { render, staticRenderFns } from "./Compras.vue?vue&type=template&id=3f4f056d&scoped=true"
import script from "./Compras.vue?vue&type=script&lang=js"
export * from "./Compras.vue?vue&type=script&lang=js"
import style0 from "./Compras.vue?vue&type=style&index=0&id=3f4f056d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4f056d",
  null
  
)

export default component.exports